import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser';
import { ConfigService } from '../core/config';

@Injectable({
  providedIn: 'root'
})
export class MixpanelService {
  private isTrackingEnabled: boolean = false;

  constructor(private configService: ConfigService) {
    // Only enable tracking in production environment
    if (this.configService.get('host') === 'prod') {
      mixpanel.init(this.configService.get('mixPanelToken'), {
        debug: false, // Always false in production
        persistence: 'localStorage',
      });
      this.isTrackingEnabled = true;
    }
  }

  track(event: string, properties?: any) {
    // Tracking is disabled in non-production environments
    if (!this.isTrackingEnabled) {
      return;
    }
    mixpanel.track(event, properties);
  }

  identify(userId: string) {
    // Tracking is disabled in non-production environments
    if (!this.isTrackingEnabled) {
      return;
    }
    mixpanel.identify(userId);
  }

  setUserProperties(userId: string, properties: { [key: string]: any }) {
    // Tracking is disabled in non-production environments
    if (!this.isTrackingEnabled) {
      return;
    }
    this.identify(userId);
    mixpanel.people.set(properties);
  }

  PAGE_VIEW: string = 'Page View';
  LOGIN: string = 'Login';
  LOGOUT: string = 'Logout';
}
